import { setAncPregBackHandler } from '@store/actions/beneficiaryAction';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { PREGNANCY_TAB_BACK_OBJECT } from './ANC/Forms/CreateAndEdit/ancConstants';

const usePregnancyTabBack = () => {
  const dispatch = useDispatch();

  const handlePregnancyTabBack = useCallback(() => {
    dispatch(setAncPregBackHandler(PREGNANCY_TAB_BACK_OBJECT));
  }, [dispatch]);

  return handlePregnancyTabBack;
};

export default usePregnancyTabBack;